<template>
  <div class="built-container">
    <el-container>
      <el-header v-loading="loading" id="header">
        <div class="nav-header" ref="header">
          <el-row>
            <el-col :span="18">
              <div class="title" v-text="title"></div>
            </el-col>
            <el-col :span="6">
              <div class="layout-right">
                <div style="margin: 10px">
                  <el-button @click.once="close">关闭</el-button>
                  <el-button type="primary" @click="onSave">
                    保存并下一步
                  </el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <div>
        <el-alert
          :title="feedback"
          type="warning"
          v-show="this.feedback && this.form.feedBack"
          effect="dark"
          description="请您按照退回意见，修改相关内容，确认无误后点击[保存并下一步]。"
          show-icon
        ></el-alert>
      </div>
      <el-container>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          v-loading="loading"
          label-width="200px"
        >
          <el-card>
            <div slot="header">
              <span>基本信息</span>
            </div>

            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名" prop="mavinName">
                  <el-input v-model="form.mavinName"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="性别">
                  <el-input
                    v-model="form.sex"
                    placeholder="自动生成，无需填写"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="民族" prop="nation">
                  <el-select
                    v-model="form.nation"
                    filterable
                    placeholder="请选择民族"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in form.nations"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="政治面貌" prop="clan">
                  <el-select
                    v-model="form.clan"
                    placeholder="请选择政治面貌"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in form.clans"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="出生年月">
                  <el-input
                    v-model="birthday"
                    placeholder="自动生成，无需填写"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="参加工作时间" prop="workTime">
                  <el-date-picker
                    v-model="form.workTime"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="籍贯" prop="bornId">
                  <el-tag closable v-if="form.bornName" @close="onBornTag">
                    {{ form.bornName }}
                  </el-tag>
                  <el-cascader
                    v-else
                    :props="borns"
                    @change="handleBorn"
                    style="width: 100%"
                  ></el-cascader>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="人员状态" prop="statues">
                  <el-select
                    v-model="form.state"
                    placeholder="请选择人员状态"
                    @change="handleJobState"
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in form.states"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item>
                  <span slot="label" style="line-height: 20px">
                    <span slot="label" style="color: red">*</span>
                    主要从事的专业方向（研究学科）
                  </span>
                  <el-cascader
                    v-model="form.speId"
                    :options="form.speTree"
                    @change="handleSpe"
                    clearable
                    style="width: 100%"
                  ></el-cascader>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item prop="minorId">
                  <span slot="label" v-show="hasMinor">二级专业</span>
                  <el-cascader
                    v-if="hasMinor"
                    v-model="form.minorIds"
                    :options="minorIds"
                    @change="handleMinor"
                    clearable
                    style="width: 100%"
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="身份证号码" prop="idCard">
                  <el-input
                    v-model="form.idCard"
                    placeholder="请输入身份证号码"
                    maxlength="18"
                    :disabled="hasInfo"
                    clearable
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="人员行业分类" prop="industry">
                  <el-select
                    v-model="form.industry"
                    placeholder="请选择人员行业分类"
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in form.industrys"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="毕业学校" prop="school">
                  <el-input
                    v-model="form.school"
                    placeholder="请输入毕业学校"
                    maxlength="80"
                    show-word-limit
                    clearable
                  />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="所学专业" prop="professionId">
                  <el-cascader
                    v-model="form.professionIds"
                    :options="form.professionTree"
                    @change="handleProfession"
                    clearable
                    style="width: 100%"
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="学历" prop="education">
                  <el-select
                    v-model="form.education"
                    placeholder="请选择学历"
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in form.educations"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="学位" prop="degree">
                  <el-select
                    v-model="form.degree"
                    placeholder="请选择学位"
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in form.degrees"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="健康状况" prop="healthy">
                  <el-select
                    v-model="form.healthy"
                    placeholder="请选择健康状况"
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in form.healthys"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="手机号码" prop="mobile">
                  <el-input
                    v-model="form.mobile"
                    placeholder="请输入手机号码"
                    maxlength="11"
                    show-word-limit
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="电子邮箱" prop="email">
                  <el-input
                    v-model="form.email"
                    maxlength="100"
                    placeholder="请输入电子邮箱"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>

          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>工作信息</span>
            </div>

            <el-col :span="24">
              <el-form-item label="工作单位" prop="deptName">
                <el-row>
                  <el-col :span="20">
                    <el-input
                      v-model="form.deptName"
                      readonly
                      placeholder="请单击后面的按钮选择"
                    ></el-input>
                  </el-col>
                  <el-col :span="4" class="text-right">
                    <el-button
                      size="medium"
                      icon="el-icon-search"
                      @click="handleDept"
                    >
                      搜索（编辑）
                    </el-button>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="单位隶属层级" prop="affiliationLevel">
                <el-select
                  v-model="form.affiliationLevel"
                  placeholder="请选择单位隶属层级"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in form.affiliationLevels"
                    :key="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="进入现单位工作时间" prop="deptWorkTime">
                <el-date-picker
                  v-model="form.deptWorkTime"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="专业技术职称" prop="appellationId">
                <el-cascader
                  v-model="form.appellationIds"
                  :options="form.appellationTree"
                  @change="handleAppellation"
                  clearable
                  style="width: 100%"
                ></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="职称取得时间" prop="appellationDate">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="form.appellationDate"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="现聘岗位名称（职务）" prop="headship">
                <el-input
                  v-model="form.headship"
                  placeholder="请输入现聘岗位名称（职务）"
                  maxlength="50"
                  show-word-limit
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="行政级别" prop="executLevel">
                <el-select
                  v-model="form.executLevel"
                  placeholder="请选择行政级别"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in form.executiveLevels"
                    :key="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="现聘岗位等级" prop="jobLevel">
                <el-cascader
                  v-model="form.jobLevelId"
                  :options="form.jobLevelTree"
                  @change="handleJobLevel"
                  :disabled="hasHire"
                  clearable
                  style="width: 100%"
                ></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="现聘岗位等级时间" prop="jobTime">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="form.jobTime"
                  value-format="yyyy-MM-dd"
                  :disabled="hasHire"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="兼聘双肩挑岗位等级" prop="dualityJobLevel">
                <el-select
                  v-model="form.dualityJobLevel"
                  placeholder="请选择兼聘双肩挑岗位等级"
                  :disabled="hasHire"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in form.dualityJobLevels"
                    :key="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                label="兼聘双肩挑岗位等级时间"
                prop="dualityJobTime"
              >
                <el-date-picker
                  type="date"
                  v-model="form.dualityJobTime"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="hasHire"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="isHire">
                <span slot="label" style="line-height: 20px">
                  前期是否在事业单位聘用专业技术二级岗位
                </span>
                <el-select
                  v-model="form.isHire"
                  @change="handleHire"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in form.hires"
                    :key="item.value"
                    :value="JSON.parse(item.value)"
                    :label="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="employConditon">
                <span slot="label" style="line-height: 20px">
                  <span slot="label" style="color: red">*</span>
                  前期入选专业技术二级岗位聘用条件
                </span>
                <el-select
                  v-if="this.form.isHire"
                  v-model="form.employConditon"
                  placeholder="请选择聘用条件"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in form.employConditons"
                    :key="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-select
                  v-else
                  v-model="form.employConditon"
                  placeholder="请选择聘用条件"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in form.employConditons2"
                    :key="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item prop="practFruit">
                <span slot="label" style="line-height: 20px">
                  聘用正高级岗位以来的主要业绩、贡献和成果
                </span>
                <el-input
                  type="textarea"
                  :rows="10"
                  resize="none"
                  v-model="form.practFruit"
                  placeholder="请输入聘用正高级岗位以来的主要业绩、贡献和成果"
                  maxlength="1000"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-card>
        </el-form>
      </el-container>
    </el-container>
    <search-dept ref="SearchDept" @selectd="onSelectd"></search-dept>
  </div>
</template>
  
<script>
import SearchDept from '@/components/SearchDept/Index.vue';
import { replZero } from '@/utils/validate';
import { getBase, updateBase } from '@/api/position/mavin/base.js';
import { listArea } from '@/api/infos/area.js';
import { treeMinor } from '@/api/infos/minor.js';
import rules from './rules.js';

export default {
  data() {
    var validateMinorId = (rule, value, callback) => {
      if (this.hasMinor && value == '') {
        callback(new Error('请选择二级专业!'));
      } else {
        callback();
      }
    };
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error('邮箱不能为空'));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的邮箱格式'));
        }
      }, 100);
    };
    rules.minorId = [{ validator: validateMinorId, trigger: 'blur' }];
    rules.email = [{ required: true, trigger: 'blur', validator: checkEmail }];
    return {
      loading: false,
      title: '专家信息填写',
      feedback: '',
      form: {},
      borns: {},
      idCard: '',
      minorIds: [],
      rules: rules
    };
  },
  components: {
    SearchDept
  },
  computed: {
    birthday() {
      return (
        this.form.birthday &&
        this.moment(this.form.birthday).format('YYYY-MM-DD')
      );
    },
    hasInfo() {
      return this.idCard != null;
    },
    hasMinor() {
      return this.minorIds && this.minorIds.length;
    },
    hasHire() {
      return this.form.state === '企业职工';
    }
  },
  methods: {
    buildBorns() {
      this.borns = {
        lazy: true,
        emitPath: false,
        lazyLoad(node, resolve) {
          const { level } = node;
          listArea(node.value).then(res => {
            const nodes = res.map(item => ({
              value: item.id,
              label: item.name,
              leaf: level >= 2
            }));

            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          });
        }
      };
    },
    handleBorn(value) {
      this.form.bornId = value;
    },
    onBornTag() {
      this.form.bornName = null;
    },
    handleJobState() {
      if (this.hasHire) {
        this.form.jobLevelId = '';
        this.form.jobTime = null;
        this.form.dualityJobLevel = '';
        this.form.dualityJobTime = null;
      } else {
        this.form.isHire = true;
      }
    },
    handleSpe(value) {
      this.form.speId = parseInt(value[value.length - 1]);
      this.treeMinor(this.form.speId, 'minorIds', 'minorId', true);
    },
    treeMinor(speId, minorIdsName, minorIdName, trimValue) {
      if (speId == 0) {
        this[minorIdsName] = [];
        return;
      }
      this.loading = true;
      treeMinor(speId).then(res => {
        this.loading = false;

        this[minorIdsName] = res;
        if (trimValue) {
          this.form[minorIdName] = '';
        }
      });
    },
    handleMinor(value) {
      this.form.minorId = parseInt(value[value.length - 1]);
    },
    handleProfession(value) {
      this.form.professionId = parseInt(value[value.length - 1]);
    },
    handleDept() {
      this.$refs.SearchDept.show();
    },
    onSelectd(deptId, deptName) {
      this.form.deptId = deptId;
      this.form.deptName = deptName;
    },
    handleAppellation(value) {
      this.form.appellationId = parseInt(value[value.length - 1]);
    },
    handleJobLevel(value) {
      this.form.jobLevelId = parseInt(value[value.length - 1]);
    },
    handleHire() {
      this.form.employConditon = '';
    },
    onSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          replZero(this.form, 'speId');
          replZero(this.form, 'minorId');
          replZero(this.form, 'jobLevelId');
          this.loading = true;
          updateBase(this.form)
            .then(res => {
              this.$router.push(`/position/base/review/submit/${res}`);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    getData(mavinEid) {
      this.loading = true;
      getBase(mavinEid)
        .then(res => {
          this.form = res;
          this.feedback = res.feedBack;
          this.idCard = res.idCard;
          this.treeMinor(this.form.speId, 'minorIds', 'minorId');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      window.close();
    }
  },
  created() {
    this.buildBorns();
    this.getData(this.$route.params.mavinEid);
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin-top: 10px;
}
</style>  